import React, { useState } from "react";
import { Box, Grid, Typography, TextField, Button, Paper, Alert } from "@mui/material";
import { MdOutlinePayments } from "react-icons/md";
import { insert_pec_payment } from "redux/payments/insert_pec_payment";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

const quickAmounts = [
  1000000, 5000000, 10000000, 50000000, 100000000, 500000000,
];

const DepositModule = () => {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const handleQuickSelect = (value) => {
    setAmount(value * 10);
  };

  const formatNumber = (value) => {
    if (!value) return "";
    return Number(value).toLocaleString("en-US");
  };

  const parseNumber = (value) => {
    return value.replace(/,/g, "");
  };

  const handleClickInsertPayment = async () => {
    console.log("Amount:", amount);
    console.log("Description:", description);
    try {
      const response = await insert_pec_payment({
        request_amount: amount,
        payment_source:"berelian",
        description,
      });
      console.log("Payment request inserted successfully:", response);
      if (
        response.data.response.is_successful &&
        response.data.response.data.payment_url
      ) {
        window.location.href = response.data.response.data.payment_url;
      } else {
        handleNotificationAlertTrySelect(response);
      }
    } catch (error) {
      console.error("Error inserting payment request:", error);
      handleNotificationAlertCatch();
    }
  };

  return (
    <Grid item xs={12} md={5}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 4,
          height: "100%",
        }}
      >
        <Typography variant="h6" fontWeight="bold" mb={3}>
          افزایش موجودی
        </Typography>

        <Typography fontSize={13} mb={1}>
          مبلغ (ریال)
        </Typography>
        <TextField
          fullWidth
          value={formatNumber(amount)}
          onChange={(e) => {
            const rawValue = parseNumber(e.target.value);

            if (/^\d*$/.test(rawValue)) {
              setAmount(rawValue);
            }
          }}
          placeholder="مبلغ مورد نظر را وارد کنید"
          sx={{ mb: 3 }}
        />

        <Grid container columns={12} spacing={1} mb={3}>
          {quickAmounts.map((item) => (
            <Grid item xs={6} key={item}>
              <Box
                min
                onClick={() => handleQuickSelect(item)}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 3,
                  px: 1,
                  py: 2,
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  minWidth: "100px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <Typography fontSize={13}>
                  {item.toLocaleString()} تومان
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Typography fontSize={13} mb={1}>
          توضیحات (اختیاری)
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="مثلاً: شارژ حساب معاملاتی"
          sx={{ mb: 3 }}
        />
       {/* <Alert severity="warning" sx={{mb:3}}>
          <p>
            کاربر گرامی متاسفانه به دلیل اختلالات بانکی تراکنش بانک های تجارت ،
            ملی ، صادرات و توسعه صادرات با اختلال رو به رو هستند .
          </p>
        </Alert> */}

        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={<MdOutlinePayments />}
          sx={{
            py: 1.5,
            borderRadius: 3,
            fontWeight: "bold",
          }}
          onClick={handleClickInsertPayment}
        >
          انتقال به درگاه پرداخت
        </Button>
      </Paper>
    </Grid>
  );
};

export default DepositModule;
